import { generatePath } from 'react-router';

import { SELECTED_CLUSTER_PARAM } from './searchParams';

export interface NotificationTarget {
  kind: string;
  params: Record<string, string>;
}

// Notification target kinds -> portal routes. Must stay in sync with AppRouter.
// `:name` tokens are filled from the target params, in the path and in query values.
export const NOTIFICATION_TARGET_ROUTES: Record<string, string> = {
  'caas.cluster': `/reports/caas-clusters?${SELECTED_CLUSTER_PARAM}=:clusterName`,
  'provision.os_project': '/products/:productId/osprojects/:juiceGroup/:cloudId/:osprojectName',
  'provision.product': '/products/:productId',
  'onboarding.review': '/onboarding/admin-review?email=:email',
};

const fillQuery = (queryTemplate: string, params: Record<string, string>): string => {
  const query = new URLSearchParams();

  new URLSearchParams(queryTemplate).forEach((value, key) => {
    if (!value.startsWith(':')) {
      query.append(key, value);
      return;
    }

    const param = params[value.slice(1)];

    if (param === undefined || param === '') {
      throw new Error(`Missing query param ${value}`);
    }

    query.append(key, param);
  });

  return query.toString();
};

export const resolveNotificationTarget = ({
  kind,
  params,
}: NotificationTarget): string | undefined => {
  const route = Object.hasOwn(NOTIFICATION_TARGET_ROUTES, kind)
    ? NOTIFICATION_TARGET_ROUTES[kind]
    : undefined;

  if (!route) {
    return undefined;
  }

  const [pathTemplate = '', queryTemplate] = route.split('?');

  try {
    const path = generatePath(pathTemplate, params);

    return queryTemplate ? `${path}?${fillQuery(queryTemplate, params)}` : path;
  } catch {
    return undefined;
  }
};
